import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { messages as i18n } from '@teem/constants/messages';
import { LoaderService } from '@teem/app/core/services/loader.service';
import { OrderService } from '@teem/app/core/services/order.service';
import { ACTIONS as ORDER_ACTIONS } from '@teem/constants/order';
import { RejectionReasonComponent } from '@teem/app/features/dashboard/modals/rejection-reason/rejection-reason.component';
@Component({
  selector: 'app-order-placed-modal',
  templateUrl: './order-placed-modal.component.html',
  styleUrls: ['./order-placed-modal.component.scss']
})
export class OrderPlacedModalComponent implements OnInit {
  @Input() message: string = 'Order is placed';
  @Input() orderId: string = '';
  @Input() isAutoAccept: any;

  constructor(
    public activeModal: NgbActiveModal,
    private loaderService: LoaderService,
    private orderService: OrderService,
    private modalService: NgbModal 
  ) {

  }

  ngOnInit(): void {
  }

  accept() {
    this.activeModal.close('accepted');
    Swal.fire({
      title: i18n.are_you_sure_want_accept_order,
      icon: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: '#ee3a7a',
      confirmButtonText:
        i18n.accept_order,
      cancelButtonText:
        i18n.cancel
    }).then(result => {
      if (result.value) {
        this.loaderService.startLoading();
        this.orderService.action({ 'do': ORDER_ACTIONS.MARK_AS_ACCEPT, 'uuid': this.orderId }).subscribe(data => {
          Swal.fire(i18n.alert.success, i18n.order.marked_as_accepted, 'success');
          this.loaderService.stopLoading();
        }, err => {
          this.loaderService.stopLoading();
          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        });
      }
    });
  }

  reject() {
    this.activeModal.close('rejected');
    Swal.fire({
      title: i18n.are_you_sure_want_reject_order,
      icon: 'warning',
      input: 'text',
      html: `<label style="display:block; text-align:left; margin-bottom:5px;">${i18n.enter_rejection_reason}<span class="required-star">*</span></label>`,
      inputPlaceholder: i18n.type_reason_here,
      inputValidator: (value) => {
        if (!value) {
          return i18n.reason_required;
        }
        return null;
      },
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: '#ee3a7a',
      confirmButtonText: i18n.reject_order,
      cancelButtonText: i18n.cancel
    }).then(result => {
      if (result.isConfirmed && result.value) {
        const reason = result.value;
        this.loaderService.startLoading();
        this.orderService.action({
          'do': ORDER_ACTIONS.MARK_AS_REJECTED,
          'uuid': this.orderId,
          'reason': reason
        }).subscribe(data => {
          Swal.fire(i18n.alert.success, i18n.order.marked_as_declined, 'success');
          this.loaderService.stopLoading();
        }, err => {
          this.loaderService.stopLoading();
          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        });
      }
    });
  }

  close() {
    this.activeModal.dismiss('closed');
  }

}
